// import dependencies
import React from 'react'
import { Form, Button } from 'semantic-ui-react'

const EmailFormInputObj = props =>
  props.arr.map((entry, i) => (
    <div key={i}>
      {i === 0 ? <h5>{props.statename}</h5> : null}
      <Form.Group widths="equal">
        <Form.Input
          type="text"
          placeholder={`${props.statename} Name #${i + 1}`}
          statename={props.statename.toLowerCase()}
          name="name"
          value={entry.name}
          onChange={(e, fields) => props.handleObjChange(e, i, fields)}
        />
        <Form.Input
          type="email"
          placeholder={`${props.statename} Email #${i + 1}`}
          statename={props.statename.toLowerCase()}
          name="email"
          value={entry.email}
          onChange={(e, fields) => props.handleObjChange(e, i, fields)}
          // required if first 'To' row
          required={props.statename === 'To' && i + 1 === 1 ? true : false}
        />
        {/* add(+) button for first row, remove(-) button for all others */}
        {i > 0 ? (
          <Button
            size="mini"
            statename={props.statename.toLowerCase()}
            onClick={(e, fields) => props.handleObjRemove(e, i, fields)}
            title="remove"
          >
            -
          </Button>
        ) : (
          <Button
            size="mini"
            statename={props.statename.toLowerCase()}
            onClick={(e, fields) => props.handleObjAdd(e, fields)}
            title="add another"
          >
            +
          </Button>
        )}
      </Form.Group>
    </div>
  ))

export default EmailFormInputObj



// WEBPACK FOOTER //
// ./src/components/EmailFormInputObj.js